import {ImageModeValues} from '@wix/wixstores-client-core/dist/es/src/media/constants';
import cx from 'classnames';
import React from 'react';
import stylesParams from '../../../../components/ProductPage/stylesParams';
import {TextualOptionType} from '../../../constants';
import {LayoutComponentProps} from '../../../types/app-types';
import {ConditionalRender} from '../../ConditionalRender/ConditionalRender';
import {ProductDiscountName} from '../../ProductDiscountName/ProductDiscountName';
import {ProductName} from '../../ProductName/ProductName';
import {ProductOptions} from '../../ProductOptions/ProductOptions';
import {ProductPageButtonsContainer} from '../../ProductPageButtonsContainer/ProductPageButtonsContainer';
import {ProductPaymentBreakdown} from '../../ProductPaymentBreakdown/ProductPaymentBreakdown';
import {ProductPrice} from '../../ProductPrice/ProductPrice';
import {ProductSku} from '../../ProductSku/ProductSku';
import {ViewMore} from '../../ViewMore/ViewMore';
import {Cell} from '../Cell/Cell';
import {ResponsiveGallery} from '../ResponsiveLayout/ResponsiveGallery/ResponsiveGallery';
import {CloseQuickView} from './CloseQuickView/CloseQuickView';
import s from './QuickViewLayout.scss';
import {SPECS} from '../../../specs';

export const QuickViewLayout: React.FunctionComponent<LayoutComponentProps> = ({settings, globals}) => {
  const {product, hasDiscountName, hasPaymentOptionsBreakdown, styles, useExperiments} = globals;
  const addDiscountsToVariantsEnabled = useExperiments.enabled(SPECS.AddDiscountsToVariantsItemsQueriesPPOOI);
  const discountName = addDiscountsToVariantsEnabled
    ? product.itemDiscount?.automaticDiscountRuleNames?.join('\u00B7')
    : product.itemDiscount?.discountRuleName;
  const quickViewTextualOptionType = styles.get(stylesParams.quickView_textualOptionType);
  return (
    <div className={s.content}>
      <CloseQuickView />

      <section className={cx(s.col, s.left)}>
        <Cell className={s.gallery}>
          <ResponsiveGallery
            media={product.media}
            imageMode={ImageModeValues.FIT}
            imageRatio={settings.imageRatioId}
            maxRatio={1}
            productName={product.name}
          />
        </Cell>
      </section>
      <section className={cx(s.col, s.right)}>
        <Cell>
          <ProductName name={product.name} />
        </Cell>

        <Cell className={s.price}>
          <ProductPrice />
        </Cell>

        {hasDiscountName && (
          <ConditionalRender by="productPage_showDiscountName">
            <Cell>
              <ProductDiscountName name={discountName} />
            </Cell>
          </ConditionalRender>
        )}

        {hasPaymentOptionsBreakdown && (
          <ConditionalRender by="productPage_paymentOptionsBreakdown">
            <Cell>
              <ProductPaymentBreakdown />
            </Cell>
          </ConditionalRender>
        )}

        <Cell className={s.sku}>
          <ProductSku />
        </Cell>

        <Cell className={s.options}>
          <ProductOptions quickViewTextualOptionType={quickViewTextualOptionType as TextualOptionType} />
        </Cell>

        <Cell className={s.actions}>
          <ProductPageButtonsContainer />
        </Cell>

        <Cell className={s.viewMore}>
          <ViewMore />
        </Cell>
      </section>
    </div>
  );
};
